import { Languages, MonitorCog, Moon, Sun } from 'lucide-react'
import { useState } from 'react'
import { useI18n } from '../core/i18n'
import { useTheme } from '../core/theme'
import type { ThemeMode } from '../types'

export function DisplayControls() {
  const [open, setOpen] = useState(false)
  const { locale, setLocale, tr } = useI18n()
  const { mode, setMode } = useTheme()
  const modes: { value: ThemeMode; label: string; icon: typeof Sun }[] = [
    { value: 'system', label: tr.system, icon: MonitorCog },
    { value: 'light', label: tr.light, icon: Sun },
    { value: 'dark', label: tr.dark, icon: Moon },
  ]
  return (
    <div className="display-control">
      <button className="icon-button glass-subtle" onClick={() => setOpen((value) => !value)} aria-label={`${tr.language} 및 ${tr.appearance}`} aria-expanded={open}>
        <Languages size={19} />
      </button>
      {open && (
        <div className="display-popover glass-panel" role="dialog" aria-label={`${tr.language} 및 ${tr.appearance}`}>
          <div>
            <span className="control-label">{tr.language}</span>
            <div className="segmented">
              <button className={locale === 'ko' ? 'active' : ''} onClick={() => setLocale('ko')}>한국어</button>
              <button className={locale === 'en' ? 'active' : ''} onClick={() => setLocale('en')}>English</button>
            </div>
          </div>
          <div>
            <span className="control-label">{tr.appearance}</span>
            <div className="theme-grid">
              {modes.map(({ value, label, icon: Icon }) => (
                <button key={value} className={mode === value ? 'active' : ''} onClick={() => setMode(value)}><Icon size={16} />{label}</button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
